/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Emailsent1Inputs */

const zh_password_emailsent1 = /** @type {(inputs: Password_Emailsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码设置邮件已发送`)
};

const en_password_emailsent1 = /** @type {(inputs: Password_Emailsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password setup email sent`)
};

const es_password_emailsent1 = /** @type {(inputs: Password_Emailsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de configuración de contraseña enviado`)
};

/**
* | output |
* | --- |
* | "Password setup email sent" |
*
* @param {Password_Emailsent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_emailsent1 = /** @type {((inputs?: Password_Emailsent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Emailsent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_emailsent1(inputs)
	if (locale === "en") return en_password_emailsent1(inputs)
	return es_password_emailsent1(inputs)
});
export { password_emailsent1 as "password_emailSent" }